import { isUndefined, isNull, isEmpty, isPlainObject } from "lodash";

export const isValid = (value) => {
  return !isUndefined(value) && !isNull(value) && (!isPlainObject(value) || isPlainObject(value) && !isEmpty(value)) && value != "" && value != 0
}

export const isNotValid = (value) => {
  return !isValid(value)
}